import { graphql } from '~publish/graphql'
import type { FragmentOf } from '~publish/graphql'

/**
 * The channel fields the reply-form subtree reads: `avatar`/`name` for the
 * author row, `service`/`type` for the `CommunityConfig` capability lookups
 * (character limits, AI suggestions, mention-by-text), and `id` for tracking.
 *
 * Kept in its own module importing only `graphql` so the channel producer
 * queries can spread it without pulling the reply-form component tree into a
 * runtime import cycle. Lives under `fragments/` so the graphql-codegen client
 * preset discovers it.
 */
export const EngagementReplyForm_Channel = graphql(/* GraphQL */ `
  fragment EngagementReplyForm_Channel on Channel @_unmask {
    id
    name
    avatar
    service
    type
  }
`)

export type EngagementReplyFormChannel = FragmentOf<
  typeof EngagementReplyForm_Channel
>
